import { UAParser } from 'ua-parser-js'

interface UserAgent {
  readonly source: string
  readonly os: string | undefined
  readonly osVersion: number | undefined
  readonly browser: string | undefined
  readonly browserVersion: number
}

export function parseUserAgent(uaString: string): UserAgent {
  const result: UAParser.IResult = new UAParser(uaString).getResult()

  const os = uaString ? result.os.name : ''
  const osVersion = result.os.version
  const browser = result.browser.name
  const browserVersion = uaString ? result.browser.version : null

  const ua: UserAgent = Object.freeze({
    source: uaString,
    os,
    osVersion: osVersion ? parseInt(osVersion, 10) : 0,
    browser,
    browserVersion: browserVersion ? parseFloat(browserVersion) : 0,
  })

  return ua
}

// ! This should be updated quarterly :(
export function isAllyPreferred(
  browserName: string,
  browserVersion: number,
): boolean {
  let isPreferred = false

  switch (browserName) {
    case 'Chrome':
      isPreferred = browserVersion >= 100
      break
    case 'Chrome WebView':
      isPreferred = browserVersion >= 100
      break
    case 'Safari':
      isPreferred = browserVersion >= 15.3
      break
    case 'Mobile Safari':
      isPreferred = browserVersion >= 15.3
      break
    case 'Edge':
      isPreferred = browserVersion >= 101
      break
    case 'Firefox':
      isPreferred = browserVersion >= 99
      break
    case 'Opera':
      isPreferred = browserVersion >= 90
      break
    default:
      isPreferred = false
  }
  return isPreferred
}
